import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Slider from 'react-slick';
import { v4 } from 'node-uuid';
import { LoadingIndicator } from 'common/components/preloader';
import SubcategoryIcon from 'common/components/subcategory_icon';
import { MOBILE_BREAKPOINT_PX, DESKTOP_BREAKPOINT_PX } from 'common/variables';

const PrevButton = ({onClick}) => {
  return(
    <i className="fa fa-angle-left btn-prev" onClick={onClick}/>
  )
}

const NextButton = ({onClick}) => {
  return(
    <i className="fa fa-angle-right btn-next" onClick={onClick}/>
  )
}

const SETTINGS = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  prevArrow: <PrevButton/>,
  nextArrow: <NextButton/>,
  responsive: [
    {
      breakpoint: MOBILE_BREAKPOINT_PX,
      settings: { slidesToShow: 1, slidesToScroll: 1, dots: false }
    },
    {
      breakpoint: DESKTOP_BREAKPOINT_PX,
      settings: { slidesToShow: 3, slidesToScroll: 3 }
    }
  ]
};

export default class CategorySlider extends Component {
  UNSAFE_componentWillMount() {
    const { fetchCategoriesIfNeeded } = this.props;
    fetchCategoriesIfNeeded();
  }

  render() {
    const { cats } = this.props;

    if (!cats.length) {
      return (<LoadingIndicator />);
    }

    return (
      <div className="row expanded categories-slider">
        <div className="columns small-16">
          <Slider {...SETTINGS}>
            {cats.map(cat => (
              <div key={v4()}>
                <div className="tile subcategory">
                  <Link className="category-link" to={`/${cat.slug}/`}>
                    <SubcategoryIcon subcat={cat} />
                    <h3>{ cat.name }</h3>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

CategorySlider.propTypes = {
  fetchCategoriesIfNeeded: PropTypes.func.isRequired,
  cats: PropTypes.array.isRequired,
};
